import { useSelector } from 'react-redux';
import styles from './DetailsDocuments.module.scss';
import AsideFixedBox from '../../../universal_components/Aside/AsideFixedBox/AsideFixedBox';
import MainContainerLeftControl from '../../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import { isMobile } from 'react-device-detect';
import { useEffect, useState } from 'react';

const DetailsDocuments = () => {
  const [docum, setDocum] = useState();
  const documRedux = useSelector((state) => state.detailsDocuments);

  useEffect(() => {
    if (!documRedux) return;
    setDocum(documRedux);
  }, [documRedux]);

  const options = '250px';

  return (
    <section className={styles.constituentDocuments}>
      <MainContainerLeftControl widthAside={options} data={<AsideFixedBox docum={docum ?? []} />}>
        <h1 className="visually-hidden">Учредительные документы</h1>

        {isMobile && (
          <>
            <h2 className="title" style={{ marginBottom: 20, fontSize: 21, fontWeight: 600 }}>
              О НАС
            </h2>
            <div style={{ marginBottom: 27 }}>
              <AsideFixedBox docum={docum ?? []} />
            </div>
          </>
        )}
        <div dangerouslySetInnerHTML={{ __html: docum?.text }} className={styles.desc} />
        <ul className={styles.list}>
          {docum?.detailsDocuments?.map((item) => {
            return (
              <li key={item.id} className={styles.item}>
                <a href={item.file} target="_blank" rel="noreferrer">
                  <span>{item.name}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </MainContainerLeftControl>
    </section>
  );
};

export default DetailsDocuments;
